export const minBreakpoints = {
  xs: 0,
  sm: 768,
  md: 1024,
  lg: 1300
};
export const maxBreakpoints = {
  xs: 767,
  sm: 1023,
  md: 1299
};
export default {
  min: minBreakpoints,
  max: maxBreakpoints
};